
export const CheckNull = (value: any, check?: boolean) => {
  if (value == null || value == undefined) {
    if (check) {
      return "مهمان";
    } else {
      return "";
    }
  } else {
    return value;
  }
};

export const ConvertLink = (link: string) => {
  if (link) {
    return link.replace(/ /g, "-");
  } else {
    return "";
  }
};
export const ConvertLink2 = (link: string) => {
  return link.replace(/-/g, " ");
};

export const DiscountPercent = (price: number, discount: number) => {
  return Math.floor(((price - discount) / price) * 100);
};

export const ChangeDatePersian = (x: Date) => {
  return new Date(x).toLocaleDateString("fa-Ir");
};

export const convertPersianToEnglish = (text: string): string => {
  const numMap: { [key: string]: string } = {
    "۰": "0",
    "٠": "0",
    "۱": "1",
    "١": "1",
    "۲": "2",
    "٢": "2",
    "۳": "3",
    "٣": "3",
    "۴": "4",
    "٤": "4",
    "۵": "5",
    "٥": "5",
    "۶": "6",
    "٦": "6",
    "۷": "7",
    "٧": "7",
    "۸": "8",
    "٨": "8",
    "۹": "9",
    "٩": "9",
  };

  const convertedText = text
    .split("")
    .map((char) => numMap[char] || char)
    .join("");
  return convertedText;
};

export const PricePostSend = (count?: number) => {
  if (count && count >= 3) {
    return 60000;
  } else {
    return 40000;
  }
};

export const calculatePercentage = (value: number, total: number): number =>
  Number(((value / total) * 100).toFixed());
